export const safeParseJSON = (jsonString, fallback = null) => {
  try {
    return JSON.parse(jsonString);
  } catch (e) {
    console.error('Error parsing JSON: ', jsonString);
    return fallback;
  }
};
